import type { ReactNodeArray } from 'react';
import React from 'react';
import reactStringReplace from 'react-string-replace';
import matchAll from 'string.prototype.matchall';
import { StreamParticipantDisplay } from '../components/Comments/StreamParticipantDisplay';
import type { StreamParticipant } from '../types/StreamParticipant';

export function parseHyperLinks(content: string) {
  const regex = /(https?:\/\/[^\s.]+\.[\w][^\s]+)/gm;

  // @ts-ignore
  // const matches = [...content?.matchAll(regex)];

  let parsedContent: ReactNodeArray | string = content || '';
  // matches.forEach(match => {
  parsedContent = reactStringReplace(parsedContent, regex, (reactMatch: string, i: number) => {
    return (
      <a key={`link-${i}`} className="gik-stream-link" target="_blank" rel="noreferrer" href={reactMatch}>
        {reactMatch}
      </a>
    );
  });
  // });

  return parsedContent;
}

export function parseMentions(content: string, participants: StreamParticipant[]) {
  const regex = /@\[([^\]]*)\]\((.*?)\)(.*)/gm;

  // @ts-ignore
  const matches = [...matchAll(content, regex)];

  let parsedContent: ReactNodeArray | string = content || '';
  matches.forEach((match, i) => {
    const mentionStr = `@[${match[1]}](${match[2]})`;

    parsedContent = reactStringReplace(parsedContent, mentionStr, (_reactMatch: string, y: number) => {
      const userId = match[2];
      const userFullName = match[1];
      const participant = participants?.find(item => item.id === userId);

      return <StreamParticipantDisplay participant={participant} userId={userId} userFullName={userFullName} />;
    });
  });

  return parsedContent;
}

export function parseStreamContent(content: string, participants: StreamParticipant[]) {
  if (!content) return '';

  return parseHyperLinks(parseMentions(content, participants));
}
